import type {
  PlaybookId,
  PlaybookView,
} from "@repo/app-types/entities/playbook";
import type { SignalId } from "@repo/app-types/entities/signal";
import type { TeammateId } from "@repo/app-types/entities/teammate";

/** Parameters from the environment passed into all the filter logic. */
export interface FilterParams {
  playbookId?: PlaybookId;
  /**
   * Which kind of page this is, for the defaults it can save back to the
   * playbook. Set by pages that resolve their defaults from the playbook, so
   * the "Set default for everyone" action writes the view the viewer is
   * actually looking at.
   */
  view?: PlaybookView;
  /**
   * When set, scopes filter widgets to a single teammate. The teammate-group
   * filter restricts its options to groups the teammate is a member of, so
   * users can't pick a group that would yield empty data on a teammate-scoped
   * page.
   */
  teammateId?: TeammateId;
  /**
   * Signal currently in scope. The drilldown page sets this from its URL
   * param; other pages would derive it from `FilterContext.values.signalId`.
   * Used by signalMetadataFields to scope its breakdown query without depending
   * on the FilterKey lifecycle (which would otherwise be cleared by Reset
   * on the drilldown page).
   */
  signalId?: SignalId;
}

export const DEFAULT_FILTER_PARAMS: FilterParams = Object.freeze({});
